<template>
  <div>
    <!-- <v-layout row class="mt-3">
      <v-flex xs10 sm5 md3>
        <v-select
          :items="column_items"
          item-value="value"
          v-model="sort_column"
          @change="sortBy()"
          label="Sort by"
          color="black"
          clearable
          hide-details
        ></v-select>
      </v-flex>
      <v-flex xs2 sm4 md3>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'asc'"
          :disabled="asc_desc == 'desc' || sort_column == 'no_default'"
          @click="selectAscDesc('desc')"
        >
          <v-icon small>arrow_downward</v-icon>
        </v-btn>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'desc'"
          :disabled="asc_desc == 'asc' || sort_column == 'no_default'"
          @click="selectAscDesc('asc')"
        >
          <v-icon small>arrow_upward</v-icon>
        </v-btn>
      </v-flex>
    </v-layout> -->
    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-1 mt-4"
      style="background-color: white; padding: 10px; border-radius: 10px"
    >
      <template
        slot="headerCell"
        slot-scope="props"
        style="background-color: black"
        >{{ props.header.text }}</template
      >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{ props.item.no }}
        </td>
        <td class="text-xs-center">{{ props.item.store_number }}</td>
        <td>{{ props.item.store_name }}</td>

        <td class="text-xs-center">
          {{ props.item.number_of_order }}
        </td>
        <td class="text-xs-center">
          {{ props.item.delivery_amount }}
        </td>
        <td class="text-xs-center">
          {{ props.item.sales_amount }}
        </td>
      </template>
      <template slot="footer" style="border: none">
        <td class="text-xs-left">
          <strong>Total</strong>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td class="text-xs-center" style="font-weight: bold">
          {{ totalDeliveryAmount }}
        </td>
        <td class="text-xs-center" style="font-weight: bold">
          {{ totalSaleAmount }}
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    items: {
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: "Store Number",
          align: "center",
          value: "reward",
          sortable: false,
        },
        {
          text: "Store name",
          align: "center",
          value: "reward",
          sortable: false,
        },
        {
          text: "Numbers of Order",
          value: "amount",
          sortable: false,
          align: "center",
        },
        {
          text: "Delivery Amount(Excluded vat)",
          value: "use",
          sortable: false,
          align: "center",
        },
        {
          text: "Sales amount",
          value: "value_price",
          sortable: false,
          align: "center",
        },
      ],
      column_items: [
        {
          text: "Paid price (THB)",
          value: "total_paid_price",
          sortable: false,
          align: "center",
        },
      ],
      asc_desc: "asc",
      sort_column: "no_default",
      isSort: false,
    };
  },
  watch: {
    reward_report_list: {
      handler: function () {
        if (this.isSort == false) {
          this.asc_desc = "asc";
          this.sort_column = "no_default";
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      reward_report_list: (state) => state.report.reward_report_list,
      reward_report_summary: (state) => state.report.reward_report_summary,
    }),
    totalDeliveryAmount() {
      return this.items.reduce(function (previousValue, currentValue) {
        return previousValue + parseFloat(currentValue.delivery_amount);
      }, 0);
    },
    totalSaleAmount() {
      return this.items.reduce(function (previousValue, currentValue) {
        return previousValue + parseFloat(currentValue.sales_amount);
      }, 0);
    },
  },
  methods: {
    async sortBy() {
      if (this.sort_column == undefined) {
        this.sort_column = "no_default";
        this.asc_desc = "asc";
      }

      this.isSort = true;
      const send_json_data = {
        data: this.reward_report_list,
        field: this.sort_column,
        asc_desc: this.asc_desc,
      };

      await this.$store.dispatch("sortData", send_json_data);
      await this.$store.commit("report/getExportReportForm");
      this.$store.commit("report/getExportSummaryForm");
      this.isSort = false;
    },
    selectAscDesc(value) {
      this.asc_desc = value;
      this.sortBy();
    },
  },
};
</script>
<style scoped>
.sort-btn {
  cursor: pointer;
  height: 30px;
  width: 30px;
  background-color: #fafafa;
  border: 1px solid #b8b8b8;
  border-radius: 10px;
  color: #757575;
  margin-top: 10px;
  margin-left: 20px;
}
/* .main-title {
  font-size: 22px;
  font-weight: bold;
}
.text-table {
  font-weight: bold;
  line-height: 30px;
}
.title-store {
  font-size: 19px;
  font-weight: bold;
} */
</style>

